import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  TrustedRequest,
  TrustedRequestActionResponse,
} from '../models/trusted-request';

@Injectable({
  providedIn: 'root',
})
export class TrustedRequestService {
  private readonly baseUrl = `${environment.apiUrl}/admin/trusted_requests/`;

  constructor(private http: HttpClient) {}

  listRequests(): Observable<TrustedRequest[]> {
    return this.http.get<TrustedRequest[]>(this.baseUrl);
  }

  approveRequest(id: number): Observable<TrustedRequestActionResponse> {
    return this.http.post<TrustedRequestActionResponse>(
      `${this.baseUrl}${encodeURIComponent(String(id))}/approve/`,
      {}
    );
  }

  rejectRequest(
    id: number,
    trustedRevokedReason: string
  ): Observable<TrustedRequestActionResponse> {
    return this.http.post<TrustedRequestActionResponse>(
      `${this.baseUrl}${encodeURIComponent(String(id))}/reject/`,
      { trusted_revoked_reason: trustedRevokedReason }
    );
  }
}
